import * as models from './';

export class FunctionRestriction {
  restrictedFunctionType: models.RestrictedFunctionTypeEnum;
  securityAccess: models.SecurityAccessEnum;
}
